import * as React from "react";
export var LoaderType1 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#2668c5" : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
    var style = {
        borderTop: "5px solid " + color,
        borderBottom: "5px solid " + color,
        borderRight: "5px solid " + color,
    };
    return (React.createElement("div", { className: className + " loaderAlignment" },
        React.createElement("div", { className: "loader", style: style })));
};
